import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/common/empty.png';
import _imports_1 from '@/assets/img/common/lock@2x.png';
import _imports_2 from '@/assets/img/common/p@2x.png';
import _imports_3 from '@/assets/icon/icon_serve.png';
import _imports_4 from '@/assets/img/exercise/liuyuan.jpeg';
const _withScopeId = n => (_pushScopeId("data-v-06cc14e5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pageContainer" };
const _hoisted_2 = { class: "bannerContainer" };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "meetingInfo" };
const _hoisted_5 = {
    key: 0,
    class: "startTime"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = {
    key: 1,
    class: "expertInfo flexBox"
};
const _hoisted_8 = { class: "img" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "msg" };
const _hoisted_11 = { class: "expertName font-28 font-w500" };
const _hoisted_12 = { class: "hospitalName font-24" };
const _hoisted_13 = {
    class: "msg font-28",
    style: { "text-align": "right" }
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "课程详情", -1));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "line" }, null, -1));
const _hoisted_17 = [
    _hoisted_15,
    _hoisted_16
];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "课程大纲", -1));
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "line" }, null, -1));
const _hoisted_20 = [
    _hoisted_18,
    _hoisted_19
];
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "实操回放", -1));
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "line" }, null, -1));
const _hoisted_23 = [
    _hoisted_21,
    _hoisted_22
];
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "推荐", -1));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "line" }, null, -1));
const _hoisted_26 = [
    _hoisted_24,
    _hoisted_25
];
const _hoisted_27 = ["innerHTML"];
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "outlineTitle" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "line" }),
    /*#__PURE__*/ _createElementVNode("span", null, "课程大纲"),
    /*#__PURE__*/ _createElementVNode("span", { class: "line" })
], -1));
const _hoisted_29 = ["innerHTML"];
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "outlineTitle" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "line" }),
    /*#__PURE__*/ _createElementVNode("span", null, "实操回放"),
    /*#__PURE__*/ _createElementVNode("span", { class: "line" })
], -1));
const _hoisted_31 = { key: 0 };
const _hoisted_32 = {
    key: 0,
    class: "opeVideo-empty"
};
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "内容待补充～", -1));
const _hoisted_35 = [
    _hoisted_33,
    _hoisted_34
];
const _hoisted_36 = {
    key: 1,
    class: "opeVideo-list"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = { class: "title" };
const _hoisted_39 = { class: "info" };
const _hoisted_40 = { class: "cover" };
const _hoisted_41 = {
    key: 0,
    src: _imports_1,
    alt: "",
    class: "icon"
};
const _hoisted_42 = {
    key: 1,
    src: _imports_2,
    alt: "",
    class: "icon"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = {
    key: 2,
    class: "currentMeeting"
};
const _hoisted_45 = { class: "num font-32 font-w500" };
const _hoisted_46 = { class: "time font-28" };
const _hoisted_47 = ["onClick"];
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "icon-serve",
    src: _imports_3,
    alt: ""
}, null, -1));
const _hoisted_49 = [
    _hoisted_48
];
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, "咨询", -1));
const _hoisted_51 = ["onClick"];
const _hoisted_52 = ["onClick"];
const _hoisted_53 = { class: "fixed-dialog" };
const _hoisted_54 = { class: "content" };
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "提示", -1));
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "尊敬的尊享会员用户，你当前可免费参与该场共学营，是否去报名？", -1));
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "imgBox" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_4,
        alt: ""
    }),
    /*#__PURE__*/ _createElementVNode("p", null, "杨彦平老师：18939863441")
], -1));
const _hoisted_58 = [
    _hoisted_57
];
import { ref, computed, onMounted, getCurrentInstance, nextTick, onUnmounted, watch } from 'vue';
import Footer from '@/components/common/Footer.vue';
import Banner from '@/components/common/Banner.vue';
import AliPlayer from '@/components/AliPlayer/index.vue';
import AppShareItem from '@/components/common/AppShare.vue';
import courseRecommend from '@/components/course/courseRecommend.vue';
import PlanList from './planList.vue';
import { createMeetingOrder, applyMeeting, meetingIsFree, getMeetingInfo, createFreeOrder, operationVideos } from '@/api/meeting';
import { appPort, getUserId, userLogin, jumpModuleApp, weixinShare, isLogin, appFullScreen, versionCompare, goToStudy, iOSPort, PCPort, mathRound, recommendGIO } from '@/widget/index';
import { hostPath, hostPCPath } from '@/public/utils/basePath';
import { customerAct } from '@/api/data';
import { updateOrder } from '@/api/meeting';
import { getVideoUrl } from '@/api/video';
import { find } from 'lodash-es';
import { useRoute, useRouter } from 'vue-router';
import { Toast } from 'vant';
import { useAppPageBar } from '@/hooks/appPage';
import { bannerShareInfo } from '@/api/home';
export default /*#__PURE__*/ _defineComponent({
    props: {
        updatePage: {
            type: Boolean,
            default: false
        }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const route = useRoute();
        const { proxy: { $showLoading, $hideLoading, $dialog } } = getCurrentInstance();
        watch(() => props.updatePage, (n) => {
            if (n) {
                getDetail();
            }
        });
        let isLiveOpen = false;
        if (String(route.query.is_live_open) === '1') {
            isLiveOpen = true;
        }
        // 课程类型 omo online meeting
        const type = String(route.params.type);
        const isApp = appPort();
        if (isApp && !isLiveOpen) {
            appFullScreen();
        }
        const bannerStyle = ref({
            height: '4.22rem',
            width: '7.5rem'
        });
        const detail = ref({});
        const banner = ref([]);
        const meetingId = ref(Number(route.query.meetingId || 0));
        const albumId = ref(0);
        // 判断类型
        if (type == 'meeting') {
            albumId.value = Number(route.params.id || 0);
        }
        else {
            albumId.value = 0;
            meetingId.value = Number(route.params.id || 0);
        }
        // 进入课程
        const toDetail = () => {
            if (isApp) {
                goToStudy('meeting', meetingId.value);
            }
            else {
                location.assign(`${hostPath}/course/meeting/${meetingId.value}`);
            }
        };
        const userId = getUserId();
        const shareInfo = ref({});
        const meetingList = ref([]);
        const currentMeeting = ref({});
        const expertList = ref([]);
        let bannerShare = ref(false);
        const desc = computed(() => {
            if (bannerShare.value) {
                return '';
            }
            if (expertList.value.length) {
                return (expertList.value.map(item => item.expertName) +
                    '\n' +
                    expertList.value.map(item => item.expertHospitalName));
            }
            else {
                return '';
            }
        });
        // 分享设置
        let qLocation = route.query.location || '';
        let bannerId = route.query.bannerId || '';
        if (qLocation == 'banner' && bannerId && isApp) {
            bannerShareInfo(String(bannerId)).then((res) => {
                if (res.code == 200) {
                    bannerShare.value = true;
                    shareInfo.value = res.data;
                }
            });
        }
        const ios = iOSPort();
        // 判断是否要隐藏 报名按钮
        const hideBtn = computed(() => {
            let { iosInReview, vipIsFree, exerciseType, status } = detail.value;
            if (iosInReview && ios && isApp && exerciseType == 'TEAM') {
                // ios 审核中 活动商品 app中
                return true;
            }
            if (isApp && ios && exerciseType == 'TEAM' && status == 0 && !vipIsFree) {
                //  iOS APP 共学营 开放报名中，会员不免费
                return true;
            }
            return false;
        });
        // 判断是否要展示 按钮
        const showBtn = computed(() => {
            let { status, vipIsFree, exerciseType } = detail.value;
            if (hideBtn.value) {
                return false;
            }
            if (isApp && ios && exerciseType == 'TEAM' && status == 0) {
                //  iOS APP 共学营 开放报名中
                return false;
            }
            if (status === 10) {
                // 活动购买课程
                return true;
            }
            // freeBl判断是否享有会员免费权益  status -1 已结束 0 未报名 1 已报名  10 判断是否在 ios 审核期
            if ((freeBl.value && status === 1) ||
                vipIsFree !== 1 ||
                !freeBl.value ||
                status == -1) {
                return true;
            }
            return false;
        });
        const loaded = ref(false);
        const getDetail = () => {
            return new Promise(async (resolve) => {
                $showLoading();
                await getMeetingInfo(albumId.value, meetingId.value, userId, ios && isApp ? { ios: true } : undefined).then((res) => {
                    $hideLoading();
                    if (res.code == 200) {
                        detail.value = res.data;
                        expertList.value = res.data.expertList;
                        banner.value = res.data.banners;
                        if (!bannerShare.value) {
                            shareInfo.value = res.data.share || {};
                        }
                        document.title = detail.value.meetingName;
                        meetingList.value = detail.value.meetingList || [];
                        meetingId.value = detail.value.meetingId;
                        if (PCPort()) {
                            if (meetingList.value.length) {
                                location.replace(`${hostPCPath}/new/meeting/album/${albumId.value || meetingId.value}`);
                            }
                            else {
                                location.replace(`${hostPCPath}/new/meeting/meeting/${meetingId.value}`);
                            }
                        }
                        window.gio &&
                            window.gio('page.set', {
                                dep_id: detail.value.depId,
                                course_id: Number(meetingId.value)
                            });
                        if (meetingList.value?.length) {
                            currentMeeting.value = find(meetingList.value, {
                                meetingId: meetingId.value
                            });
                        }
                        loaded.value = true;
                        if (!isApp) {
                            shareInfo.value.title &&
                                weixinShare({
                                    title: shareInfo.value.title,
                                    url: location.href,
                                    desc: desc.value || shareInfo.value.desc,
                                    image: shareInfo.value.image
                                });
                        }
                        customerActFn();
                    }
                });
                if (detail.value.status === 0 && detail.value.vipIsFree === 1) {
                    // 未报名 判断是否享有会员免费权益
                    await meetingIsFree({
                        userId: userId,
                        meetingId: meetingId.value
                    }).then(res => {
                        $hideLoading();
                        if (res.code === 200) {
                            freeBl.value = res.data;
                        }
                    });
                }
                if (freeBl.value) {
                    // unlockType //解锁模式 默认0 ，1固定日期解锁，2闯关模式, 3随到随学
                    // 会员免费 创建会员订单并进入学习页 随到随学 status -1 已结束 0 未报名 1 已报名
                    if (detail.value.unlockType == 3 && detail.value.status == 0) {
                        confirmOrder(true);
                    }
                }
                else {
                    // 实操回放 有实操回放 (已购买或没有开通尊享会员)
                    if (detail.value.showPlayback) {
                        getOperationVideos();
                    }
                }
                resolve(true);
            });
        };
        // 筛选班期
        const selectMeeting = (item) => {
            meetingId.value = item.meetingId;
            getDetail();
        };
        const videosDetail = ref({});
        // 实操回放
        const getOperationVideos = () => {
            operationVideos({
                userId: userId,
                meetingId: meetingId.value
            }).then(res => {
                if (res.code === 200) {
                    videosDetail.value = res.data;
                }
            });
        };
        const videoMd5 = ref(''); // 当前播放视频md5值
        const playingInd = ref(0);
        const freeBl = ref(false); // 判断是否享有会员免费权益
        const showVipFreeDialog = ref(false);
        const orderId = ref('');
        const btnText = computed(() => {
            if (detail.value.status === 1) {
                return detail.value.payType !== 1 && !detail.value.isBuy
                    ? '已报名'
                    : '去学习';
            }
            else {
                // 当前用户是否可以免费报名
                if (detail.value.userIsFree && detail.value.status != -1) {
                    return detail.value.userIsFreeText;
                }
                return detail.value.statusText;
            }
        });
        // 创建会员免费订单
        // 报名下单时 静默跳过 0元支付流程
        const confirmOrder = async (bl) => {
            $showLoading();
            await createFreeOrder({
                userId: userId,
                meetingId: meetingId.value
            }).then(res => {
                $hideLoading();
                if (res.code === 200) {
                    orderId.value = res.data;
                }
            });
            // 更新订单状态
            await updateOrder({ userId: userId, orderId: orderId.value }).then(res => {
                if (res.code === 200) {
                    showVipFreeDialog.value = false;
                    if (!bl) {
                        Toast('报名成功');
                        getDetail();
                    }
                    else {
                        let id = Number(meetingId.value) || 0;
                        if (!id) {
                            return;
                        }
                        toLearn(id);
                    }
                }
            });
        };
        // 免费报名
        const freeOrder = () => {
            if (!isLogin) {
                userLogin();
                return;
            }
            if (freeBl.value) {
                showVipFreeDialog.value = true;
            }
            else {
                if (isApp) {
                    jumpModuleApp({
                        typeId: 'vip_member_open'
                    });
                }
                else {
                    location.href = `${hostPath}/open_vip`;
                }
            }
        };
        const beforeAliPlayerCreated = ({ key, videoId }) => {
            playingInd.value = key;
            return new Promise(resolve => {
                getVideoUrl({ params: { videoId: videoId } })
                    .then(res => {
                    if (Number(res.code) === 200) {
                        resolve({ SD: res.data.ssl_url });
                    }
                })
                    .catch(error => {
                    console.log(error);
                });
            });
        };
        // 视频播放切换
        const currentIndex = ref(0);
        const swipeChange = (current) => {
            currentIndex.value = current;
        };
        const liuFlag = ref(false); // 是否是六院的课程
        const showLiu = ref(false);
        if (meetingId.value == 10000314) {
            showLiu.value = true;
        }
        const apply = () => {
            if (isLogin) {
                let { status, actUrl } = detail.value;
                if (status == -1) {
                    Toast(btnText.value || '报名已结束');
                    return;
                }
                if (status == 10 && actUrl) {
                    // 活动商品 必须通过购买会懂会员获得兑换码兑换后观看
                    if (isApp) {
                        jumpModuleApp({
                            typeId: 'h5',
                            url: actUrl
                        });
                    }
                    else {
                        location.assign(actUrl);
                    }
                    return;
                }
                let t = detail.value.exerciseType.toUpperCase();
                let id = Number(meetingId.value) || 0;
                if (!id) {
                    return;
                }
                // detail.status -1 已结束 0 未报名 1 已报名
                if (detail.value.status === 1 && detail.value.payType !== 1) {
                    if (showLiu.value) {
                        liuFlag.value = true;
                        return;
                    }
                    // 已报名线下支付
                    toLearn(id);
                    return;
                }
                if (detail.value.status === 1) {
                    // 已报名 去学习页
                    toLearn(id);
                    return;
                }
                else if (detail.value.status !== 0) {
                    return;
                }
                if (detail.value.payType !== 1) {
                    // 线下支付
                    applyMeeting({
                        userId: userId,
                        meetingId: id,
                        sourceId: String(route.query.sourceId || '0')
                    }).then(res => {
                        if (res.code === 200) {
                            if (showLiu.value) {
                                liuFlag.value = true;
                            }
                            else {
                                $dialog.alert({
                                    title: '提示',
                                    messageAlign: 'left',
                                    message: res.data,
                                    confirmButtonText: '确定'
                                });
                            }
                            detail.value.status = 1;
                        }
                    });
                }
                else {
                    createMeetingOrder({
                        userId: userId,
                        meetingId: id
                    }, {
                        sourceId: String(route.query.sourceId || '0')
                    }).then(res => {
                        if (res.code === 200) {
                            if (isApp) {
                                jumpModuleApp({
                                    typeId: 'h5',
                                    url: `${hostPath}/learn/order/meeting/${res.data}`
                                });
                            }
                            else {
                                router.push({
                                    name: 'orderDetail',
                                    params: {
                                        module: 'meeting',
                                        orderId: res.data
                                    }
                                });
                            }
                        }
                    });
                }
            }
            else {
                userLogin();
            }
        };
        const { getRemH } = useAppPageBar();
        // 计算透明度
        const domOpacity = computed(() => {
            return scrollTop.value > 0 ? mathRound(scrollTop.value / 100, 1) : 1;
        });
        const barHeight = ref('0.56rem');
        const remToPx = (n) => {
            var rem = localStorage.getItem('rem');
            return (n * Number(rem)) / 100;
        };
        barHeight.value = getRemH() + 0.4 + 0.56 + 'rem';
        const appbar = getRemH() + 0.4 + 'rem';
        const scrollTop = ref(0);
        const contentTop = ref(0);
        const detail2 = ref();
        const detail3 = ref();
        const detail4 = ref();
        const tabRef = ref();
        let rem = Number(localStorage.getItem('rem'));
        let num = Number((88 * rem) / 100);
        if (isApp && !isLiveOpen) {
            num = remToPx(parseFloat(barHeight.value) * 100);
        }
        let top3 = 0;
        let top2 = 0;
        let top4 = 0;
        let tabh = 0;
        const tabInd = ref(1);
        const scrollFn = () => {
            scrollTop.value =
                document.documentElement.scrollTop || document.body.scrollTop;
            if (isApp && !isLiveOpen) {
                tabh = num + tabRef.value.offsetHeight;
            }
            else {
                tabh = tabRef.value.offsetHeight;
            }
            top2 = detail2.value?.offsetTop || 0;
            if (detail3.value) {
                top3 = detail3.value.offsetTop;
            }
            top4 = detail4.value.offsetTop;
            if (top4 && scrollTop.value >= top4 - tabh) {
                tabInd.value = 4;
            }
            else if (top3 && scrollTop.value >= top3 - tabh) {
                tabInd.value = 3;
            }
            else if (scrollTop.value >= top2 - tabh && top2) {
                tabInd.value = 2;
            }
            else {
                tabInd.value = 1;
            }
        };
        // 选择类别
        const chooseTab = (n) => {
            if (isApp && !isLiveOpen) {
                tabh = num + tabRef.value.offsetHeight;
            }
            else {
                tabh = tabRef.value.offsetHeight;
            }
            tabInd.value = n;
            let top = 0;
            if (n === 1) {
                top = contentTop.value;
            }
            if (n === 2) {
                top = detail2.value.offsetTop - tabh;
            }
            if (n === 3) {
                top = detail3.value.offsetTop - tabh;
            }
            if (n === 4) {
                top = detail4.value.offsetTop - tabh;
            }
            window.scrollTo({
                top: top + 2
            });
        };
        onMounted(async () => {
            await getDetail();
            nextTick(() => {
                tabh = tabRef.value.offsetHeight;
                if (isApp && !isLiveOpen) {
                    contentTop.value = tabRef.value.offsetTop - num;
                }
                else {
                    contentTop.value = tabRef.value.offsetTop;
                }
            });
            window.addEventListener('scroll', scrollFn, false);
        });
        onUnmounted(() => {
            window.removeEventListener('scroll', scrollFn, false);
        });
        // 班期选择
        const showPlan = ref(false);
        const closePlan = () => {
            setTimeout(() => {
                showPlan.value = false;
            }, 300);
        };
        //  咨询
        const serviceFn = () => {
            if (isApp && versionCompare('6.0.1')) {
                jumpModuleApp({
                    typeId: 'online_consulting',
                    dataId: meetingId.value,
                    type: 'meeting'
                });
            }
            else {
                location.href = `${hostPath}/user/service?meetingId=${meetingId.value}`;
            }
        };
        // 数据统计
        const customerActFn = () => {
            let extraData;
            if (detail.value.exerciseType === 'OMO') {
                extraData = 'omo_exercise_browse';
            }
            else {
                extraData = 'online_exercise_browse';
            }
            if (userId) {
                customerAct({
                    userId: userId,
                    typeText: extraData
                }, {
                    extra: JSON.stringify({
                        meetingId: meetingId.value
                    })
                });
            }
        };
        // 观看视频 实操视频
        const viewVideo = item => {
            if (item.lock) {
                return false;
            }
            let id = Number(meetingId.value) || 0;
            if (!id) {
                return;
            }
            let { lessonId, taskId } = item;
            // detail.status -1 已结束 0 未报名 1 已报名
            let { status, payType } = detail.value;
            if (isApp) {
                if (status === 1 && payType !== 1) {
                    // 已报名线下支付
                    if (versionCompare('8.1.0')) {
                        goToStudy('meeting', id, undefined, lessonId, taskId);
                    }
                    else {
                        goToStudy('album', item.albumId);
                    }
                    return;
                }
                if (status === 1) {
                    if (versionCompare('8.1.0')) {
                        goToStudy('meeting', id, undefined, lessonId, taskId);
                    }
                    else {
                        goToStudy('album', item.albumId);
                    }
                }
                else {
                    jumpModuleApp({
                        typeId: 'vip_detail',
                        dataId: item.albumId
                    });
                }
            }
            else {
                if (status == 1) {
                    // 已购进入学习页
                    location.assign(`${hostPath}/course/meeting/${id}?lessonId=${lessonId}&taskId=${taskId}`);
                }
                else {
                    let moduleType = item.moduleType_pc;
                    let url = '';
                    let { albumId } = item;
                    let type = moduleType.toLocaleLowerCase(); // vip masterClass pbl case open
                    if (/^(masterclass|pbl)$/.test(moduleType)) {
                        url = `/international/detail?id=${albumId}`;
                    }
                    else if (moduleType == 'vip') {
                        url = `/member/detail?id=${albumId}`;
                    }
                    else {
                        url = `/${type}/detail?id=${albumId}`;
                    }
                    location.assign(hostPath + url);
                }
            }
        };
        const clickRecommend = data => {
            // 查看推荐
            return new Promise(resolve => {
                let { meetingName, depName, exerciseType } = detail.value;
                let type = 'OMO';
                if (exerciseType == 'TEAM') {
                    type = 'online';
                }
                recommendGIO({
                    departmentType: depName,
                    recommendedCarrier: 'course',
                    course_ID: meetingId.value + '',
                    course_name: meetingName,
                    moduleType: type,
                    ...data
                }).then(() => {
                    resolve(true);
                });
            });
        };
        // 去学习 进入学习页
        const toLearn = (id) => {
            let t = detail.value.exerciseType.toUpperCase();
            if (isApp) {
                if (versionCompare('8.1.0')) {
                    goToStudy('meeting', id);
                }
                else {
                    goToStudy('meeting', detail.value.exerciseId, t);
                }
            }
            else {
                location.assign(`${hostPath}/course/meeting/${id}`);
            }
        };
        return (_ctx, _cache) => {
            const _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(type) == 'meeting')
                    ? _withDirectives((_openBlock(), _createBlock(PlanList, {
                        key: 0,
                        onClosePlan: closePlan,
                        list: meetingList.value,
                        meetingId: meetingId.value,
                        onSelectMeeting: selectMeeting
                    }, null, 8, ["list", "meetingId"])), [
                        [_vShow, showPlan.value]
                    ])
                    : _createCommentVNode("", true),
                (_unref(isApp) && !_unref(isLiveOpen))
                    ? (_openBlock(), _createBlock(AppShareItem, {
                        key: 1,
                        shareInfo: {
                            desc: _unref(desc) || shareInfo.value.desc,
                            image: shareInfo.value.image,
                            title: shareInfo.value.title,
                            url: _unref(bannerShare) ? shareInfo.value.url : ''
                        },
                        "page-title": scrollTop.value >= contentTop.value ? detail.value.meetingName : '',
                        color: scrollTop.value > 5 ? 'black' : 'white',
                        style: _normalizeStyle({
                            height: barHeight.value,
                            opacity: _unref(domOpacity),
                            'padding-top': appbar
                        }),
                        class: _normalizeClass({
                            inApp: _unref(isApp),
                            'white-bg': scrollTop.value > 5
                        })
                    }, null, 8, ["shareInfo", "page-title", "color", "style", "class"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Banner, {
                        bannerStyle: bannerStyle.value,
                        numLayout: 'rightBottom',
                        onSwipeChange: swipeChange,
                        autoplay: 0,
                        listNum: banner.value.length,
                        list: banner.value
                    }, {
                        swipeItem: _withCtx(({ item, key }) => [
                            (item.videoMd5)
                                ? (_openBlock(), _createBlock(AliPlayer, {
                                    key: 0,
                                    ref: 'videoPlayer' + key,
                                    cover: item.image,
                                    autoplay: false,
                                    index: key,
                                    "current-index": currentIndex.value,
                                    beforeCreated: beforeAliPlayerCreated,
                                    params: { key: key, videoId: item.videoMd5 },
                                    display: "h5",
                                    height: "4.22rem",
                                    width: "100%"
                                }, null, 8, ["cover", "index", "current-index", "params"]))
                                : _createCommentVNode("", true),
                            (!item.videoMd5 || videoMd5.value != item.videoMd5)
                                ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_3, null, 512)), [
                                    [_directive_lazy, item.image]
                                ])
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["bannerStyle", "listNum", "list"])
                ]),
                _createElementVNode("dl", _hoisted_4, [
                    _createElementVNode("dt", null, [
                        _createElementVNode("b", null, _toDisplayString(detail.value.meetingName), 1)
                    ]),
                    (!(detail.value.exerciseType == 'TEAM' && detail.value.unlockType == 3))
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_5, [
                            _createElementVNode("span", null, _toDisplayString(detail.value.time), 1),
                            (detail.value.exerciseType === 'OMO' || detail.value.province)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(' ' + detail.value.province + ' ' + detail.value.address), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (expertList.value.length)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("img", {
                                    src: expertList.value[0]?.expertImage,
                                    alt: ""
                                }, null, 8, _hoisted_9)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expertList.value, (item, key) => {
                                        return (_openBlock(), _createElementBlock("span", null, _toDisplayString((key > 0 ? '；' : '') + item.expertName), 1));
                                    }), 256))
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expertList.value, (item, key) => {
                                        return (_openBlock(), _createElementBlock("span", null, _toDisplayString((key > 0 ? '；' : '') + item.expertHospitalName), 1));
                                    }), 256))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", {
                                    onClick: _withModifiers(toDetail, ["stop"])
                                }, "进入课程 >", 8, _hoisted_14)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("dl", {
                    class: "contentDetail",
                    ref: (_value, _refs) => {
                        _refs['contentDetail'] = _value;
                    }
                }, [
                    _createElementVNode("dt", {
                        ref: (_value, _refs) => {
                            _refs['tabRef'] = _value;
                            tabRef.value = _value;
                        }
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["tabWrapper", {
                                    fixed: scrollTop.value >= contentTop.value
                                }]),
                            style: _normalizeStyle({ top: (_unref(isApp) && !_unref(isLiveOpen)) ? barHeight.value : 0 })
                        }, [
                            _withDirectives(_createElementVNode("div", {
                                class: _normalizeClass(["tabItem", { active: tabInd.value === 1 }]),
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (chooseTab(1)), ["stop"]))
                            }, _hoisted_17, 2), [
                                [_vShow, detail.value.htmlContent]
                            ]),
                            _withDirectives(_createElementVNode("div", {
                                class: _normalizeClass(["tabItem", { active: tabInd.value === 2 }]),
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (chooseTab(2)), ["stop"]))
                            }, _hoisted_20, 2), [
                                [_vShow, detail.value.infoHtmlContent]
                            ]),
                            (detail.value.exerciseType === 'OMO' && detail.value.showPlayback)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["tabItem", { active: tabInd.value === 3 }]),
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (chooseTab(3)), ["stop"]))
                                }, _hoisted_23, 2))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", {
                                class: _normalizeClass(["tabItem", { active: tabInd.value === 4 }]),
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (chooseTab(4)), ["stop"]))
                            }, _hoisted_26, 2)
                        ], 6)
                    ], 512),
                    _withDirectives(_createElementVNode("dd", {
                        class: "courseDetail",
                        ref: (_value, _refs) => {
                            _refs['detail1'] = _value;
                        },
                        innerHTML: detail.value.htmlContent
                    }, null, 8, _hoisted_27), [
                        [_vShow, detail.value.htmlContent]
                    ]),
                    _withDirectives(_createElementVNode("dd", {
                        class: "courseOutline",
                        ref: (_value, _refs) => {
                            _refs['detail2'] = _value;
                            detail2.value = _value;
                        }
                    }, [
                        _hoisted_28,
                        _createElementVNode("div", {
                            class: "p-b24",
                            innerHTML: detail.value.infoHtmlContent
                        }, null, 8, _hoisted_29)
                    ], 512), [
                        [_vShow, detail.value.infoHtmlContent]
                    ]),
                    (detail.value.exerciseType === 'OMO' && detail.value.showPlayback)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 0,
                            class: "courseDetail",
                            ref: (_value, _refs) => {
                                _refs['detail3'] = _value;
                                detail3.value = _value;
                            }
                        }, [
                            _hoisted_30,
                            (videosDetail.value && _unref(userId))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    (!videosDetail.value.lock && videosDetail.value.list?.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
                                        : _createCommentVNode("", true),
                                    (!videosDetail.value.lock && videosDetail.value.list?.length > 0)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_36, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videosDetail.value.list, (item, index) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: index,
                                                    onClick: ($event) => (viewVideo(item))
                                                }, [
                                                    _createElementVNode("div", _hoisted_38, _toDisplayString(item.title), 1),
                                                    _createElementVNode("p", _hoisted_39, [
                                                        _createElementVNode("span", null, "领教：" + _toDisplayString(item.expertName), 1),
                                                        _createElementVNode("i", null, _toDisplayString(item.expertHospitalName), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_40, [
                                                        (item.lock)
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                                                            : (_openBlock(), _createElementBlock("img", _hoisted_42)),
                                                        _createElementVNode("img", {
                                                            src: item.websiteCoverImage,
                                                            alt: "",
                                                            class: "img"
                                                        }, null, 8, _hoisted_43)
                                                    ])
                                                ], 8, _hoisted_37));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ], 512))
                        : _createCommentVNode("", true)
                ], 512),
                _createElementVNode("div", {
                    ref: (_value, _refs) => {
                        _refs['detail4'] = _value;
                        detail4.value = _value;
                    }
                }, [
                    _createVNode(courseRecommend, {
                        "module-type": 'meeting',
                        courseId: meetingId.value + '',
                        loaded: loaded.value,
                        isLiveOpen: _unref(isLiveOpen),
                        onClickRecommend: clickRecommend
                    }, null, 8, ["courseId", "loaded", "isLiveOpen"])
                ], 512),
                (meetingList.value?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("div", {
                            class: "flexBox meetingMsg themeColor border-box p-lr32",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (showPlan.value = true), ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_45, " 第 " + _toDisplayString(currentMeeting.value.schedules) + " 期 ", 1),
                            _createElementVNode("div", _hoisted_46, _toDisplayString(currentMeeting.value.meetingStartTime), 1)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(Footer, null, {
                    apply: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", {
                            class: _normalizeClass(["serve", { contentCenter: _unref(hideBtn) }])
                        }, [
                            _createElementVNode("div", {
                                class: "iconBox icon-serve",
                                onClick: _withModifiers(serviceFn, ["stop"])
                            }, _hoisted_49, 8, _hoisted_47),
                            _hoisted_50
                        ], 2), [
                            [_vShow, detail.value.consultingTelephone]
                        ]),
                        (detail.value.vipIsFree === 1 && detail.value.status === 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: _withModifiers(freeOrder, ["stop"]),
                                class: _normalizeClass(["freeBtn btn font-w500", { margin0: freeBl.value }])
                            }, _toDisplayString(detail.value.userIsFreeText), 11, _hoisted_51))
                            : _createCommentVNode("", true),
                        (_unref(showBtn))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["btn applyBtn font-w500", {
                                        grayBg: (detail.value.status === 1 && detail.value.payType !== 1 && !detail.value.isBuy) ||
                                            detail.value.status == -1
                                    }]),
                                onClick: _withModifiers(apply, ["stop"])
                            }, [
                                _createElementVNode("span", null, _toDisplayString(_unref(btnText)), 1)
                            ], 10, _hoisted_52))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _withDirectives(_createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("i", {
                            class: "icon",
                            onClick: _cache[5] || (_cache[5] = ($event) => (showVipFreeDialog.value = false))
                        }),
                        _hoisted_55,
                        _hoisted_56,
                        _createElementVNode("span", {
                            class: "cancel",
                            onClick: _cache[6] || (_cache[6] = ($event) => (showVipFreeDialog.value = false))
                        }, "取消"),
                        _createElementVNode("span", {
                            class: "confirm",
                            onClick: _cache[7] || (_cache[7] = ($event) => (confirmOrder()))
                        }, "立即报名")
                    ])
                ], 512), [
                    [_vShow, showVipFreeDialog.value]
                ]),
                (showLiu.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: "liuYuan",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event) => (liuFlag.value = false), ["self"]))
                    }, _hoisted_58, 512)), [
                        [_vShow, liuFlag.value]
                    ])
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
